'use client';
import Image from '@/components/Image';
import { ProductList } from './ProductList';
import { ProductSectionBlock } from '../types';

interface ProductSectionProps {
  isWeb: boolean;
  content: ProductSectionBlock;
  trackProductExp: (item: any, index: number, moduleName: string) => void;
  trackProductClick: (item: any, index: number, moduleName: string) => void;
}

export function ProductSection({
  isWeb,
  content,
  trackProductExp,
  trackProductClick,
}: ProductSectionProps) {
  const {
    pc_title,
    pc_subtitle,
    mobile_title,
    mobile_subtitle,
    pc_image,
    mobile_image,
    pc_width,
    pc_height,
    mobile_width,
    mobile_height,
    product_infos,
    module_name,
  } = content;
  const title = isWeb ? pc_title : mobile_title;
  const subtitle = isWeb ? pc_subtitle : mobile_subtitle;
  const imageAlt = pc_title;
  return (
    <section className="md:mt-[40px] md:mb-[40px] lg:mb-[100px] my-[40px] 3xl:px-[2.5vw] 2xl:px-[48px] xl:px-[32px] lg:px-[24px] px-[8px]">
      <h2
        className="leading-[24px] md:leading-[38px] text-[20px] md:text-[32px] text-center text-[#282828] font-bb"
        dangerouslySetInnerHTML={{ __html: title }}
      ></h2>
      <p
        className="mt-[6px] md:mt-[12px] text-[#282828] font-br text-[12px] md:text-[14px] leading-[14px] md:leading-[17px] text-center"
        dangerouslySetInnerHTML={{ __html: subtitle }}
      ></p>
      <section
        className={`relative lg:mt-[48px] md:mt-[24px] mt-[16px] flex flex-col lg:flex-row gap-[8px] md:gap-[12px] ${content.image_position === 'left' ? '' : 'lg:flex-row-reverse'}`}
      >
        <div className="lg:flex-1 relative lg:aspect-[906/680] aspect-[359/180] overflow-hidden rounded-[8px] flex items-center justify-center">
          <Image
            className="lg:block w-full h-auto hidden"
            src={pc_image}
            alt={imageAlt}
            width={pc_width}
            height={pc_height}
          />
          <Image
            className="lg:hidden w-full h-auto block"
            src={mobile_image}
            alt={imageAlt}
            width={mobile_width}
            height={mobile_height}
          />
        </div>
        <div className="relative flex-1 lg:aspect-[906/680]">
          <ProductList
            isWeb={isWeb}
            productsInfo={product_infos ?? []}
            handleProductClick={(index, item) => trackProductClick(item, index, module_name)}
            handleProductValidInView={(index, item) => trackProductExp(item, index, module_name)}
          />
        </div>
      </section>
    </section>
  );
}
